import { render, staticRenderFns } from "./TabUserMe.vue?vue&type=template&id=39b2ed00&scoped=true"
import script from "./TabUserMe.vue?vue&type=script&lang=js"
export * from "./TabUserMe.vue?vue&type=script&lang=js"
import style0 from "./TabUserMe.vue?vue&type=style&index=0&id=39b2ed00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2ed00",
  null
  
)

export default component.exports